/*
 * @Author: Tommy Chen weiyao_85@163.com
 * @Date: 2025-01-23 16:37:19
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-06-26 10:13:20
 * @FilePath: /help.center.intl/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/quick",
    name: "quick",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/quick.vue"),
  },
  {
    path: "/release",
    name: "release",
    component: () => import(/*发布说明列表*/ "../views/release.vue"),
  },
  {
    path: "/releaseArticle",
    name: "releaseArticle",
    component: () => import(/*发布说明文章*/ "../views/releaseArticle.vue"),
  },

  {
    path: "/ArticleList",
    name: "ArticleList",
    component: () => import(/*目录树页面*/ "../views/ArticleList.vue"),
  },
  {
    path: "/JiSu",
    name: "JiSu",
    component: () => import(/*极速智能配置页面*/ "../views/JiSu.vue"),
  },
  {
    path: "/ASN",
    name: "ASN",
    component: () => import(/*ASN页面*/ "../views/ASN.vue"),
  },
  {
    path: "/quickstartguide",
    name: "quickstartguide",
    component: () => import(/*ASN页面*/ "../views/quickstartguide.vue"),
  },
  {
    path: "/ispcloud",
    name: "ispcloud",
    component: () => import(/*ASN页面*/ "../views/ispcloud/home.vue"),
  },
  {
    path: "/isp",
    name: "isp",
    component: () => import(/*ASN页面*/ "../views/isp/home.vue"),
  },
  {
    path: "/ispQuickStartGuide",
    name: "ispQuickStartGuide",
    component: () => import(/*ASN页面*/ "../views/isp/quickstartguide.vue"),
  },
  {
    path: "/ispRelease",
    name: "ispRelease",
    component: () => import(/*发布说明列表*/ "../views/isp/release.vue"),
  },
  {
    path: "/ispAsn",
    name: "ispAsn",
    component: () => import(/*ASN页面*/ "../views/ASN.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.NODE_ENV === 'production' ? "/help/" : "/",
  routes,
});

// 添加路由守卫来处理刷新问题
router.beforeEach((to, from, next) => {
  // 如果是刷新页面且路径是根路径，但有查询参数，尝试重定向到正确的路由
  if (to.path === '/' && to.query.id && !to.name) {
    // 检查是否有ArticleList相关的查询参数
    if (to.query.id) {
      next({
        name: 'ArticleList',
        query: to.query
      });
      return;
    }
  }
  next();
});

export default router;
